export const money = (v: number) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 2 }).format(v);
export const percent = (v: number) => new Intl.NumberFormat("fr-FR", { style: "percent", maximumFractionDigits: 2 }).format(v);
